<template>
    <div>
        <h1 class="display-heading">Create Company Admin</h1>
        <form @submit.prevent="submitChangePassword">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>Full Name</label>

                        <input type="text" name="fullName" ref="fullName"
                            data-vv-as="full name" data-vv-validate-on="blur"
                            placeholder="Full Name" v-model="form.fullName" v-validate="'required'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('fullName')
                            }">

                        <div v-show="validationErrors.has('fullName')" class="invalid-feedback">
                            {{ validationErrors.first('fullName') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>Login Email Address</label>

                        <input type="text" name="loginEmailAddress" ref="loginEmailAddress" data-vv-as="login email address" data-vv-validate-on="blur"
                            placeholder="Enter Login Email Address" v-model="form.email" v-validate="'required|email'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('loginEmailAddress')
                            }">

                        <div v-show="validationErrors.has('loginEmailAddress')" class="invalid-feedback">
                            {{ validationErrors.first('loginEmailAddress') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>New Password</label>

                        <input type="password" name="newPassword" ref="newPassword" data-vv-as="new password" data-vv-validate-on="blur"
                            placeholder="Enter Your New Password" v-model="form.newPassword" v-validate="'required'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('newPassword')
                            }">

                        <div v-show="validationErrors.has('newPassword')" class="invalid-feedback">
                            {{ validationErrors.first('newPassword') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>Confirm New Password</label>

                        <input type="password" name="confirmNewPassword" ref="confirmNewPassword" data-vv-as="confirm new password" data-vv-validate-on="blur"
                            placeholder="Confirm Your New Password" v-model="form.confirmNewPassword" v-validate="'required|confirmed:newPassword'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('confirmNewPassword')
                            }">

                        <div v-show="validationErrors.has('confirmNewPassword')" class="invalid-feedback">
                            {{ validationErrors.first('confirmNewPassword') }}
                        </div>
                    </div>
                </div>
            </div>

            <p :class="{
                'text-danger': !resetSuccess
            }">
                {{ createUserMessage }}
            </p>

            <button @click="submitChangePassword" class="btn btn-primary btn-primary-insv mr-2" type="button">Create New Admin</button>
            <button @click="cancelAddAdmin" class="btn btn-secondary" type="button">Cancel</button>
        </form>
    </div>
</template>

<script>
export default {
    'name': 'CompanyAdminsAdd',
    data () {
        return {
            'form': {
                'email': '',
                'fullName': '',
                'newPassword': '',
                'confirmNewPassword': ''
            },
            'createUserMessage': '',
            'resetSuccess': false
        };
    },
    'methods': {
        submitChangePassword () {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    this.axios.post('Company/CreateAdmin', {
                        'e': this.form.email,
                        'p': this.form.newPassword,
                        'f': this.form.fullName
                    }).then(() => {
                        this.resetSuccess = true;
                        this.createUserMessage = 'New company account has been created!';

                        this.$router.push({ 'name': 'company-admins' });
                    }).catch((error) => {
                        this.resetSuccess = false;
                        if (error && error.response && error.response.data) {
                            debugger;
                            this.createUserMessage = error.response.data
                                .message;
                        } else {
                            this.createUserMessage = 'An error has occured. Please try again.';
                        }
                    });
                }
            });
        },
        cancelAddAdmin () {
            this.$router.push({ 'name': 'company-admins' });
        },
        spreadRegistrationErrors (errors) {
            let errorList = [];

            let firstLayerErrors = errors.map(e => e.e);

            firstLayerErrors.forEach(err => {
                if (err.length > 0) {
                    errorList.push(...err);
                }
            });

            return errorList;
        }
    }
};
</script>
